export default {
      id: "tooltip_tail-usage",
      viewBox: "0 0 23 11",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#tooltip_tail",
      toString: function () {
        return this.url;
      }
    }